import "./resort-condition.scss"

require.context("./static", false, /\.(svg)$/)
